import React, { useEffect, useState } from "react";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppInput from "components/Input/AppInput";
import { Box, FormGroup, makeStyles, Typography } from "@material-ui/core";
import { YupValidations } from "utils/validate";
import AppColor from "utilities/AppColor";
import AppButton from "components/CustomButtons/AppButton";
import { Link } from "react-router-dom";
import { CLIENT_TYPE } from "config/AppConfig";
import InputAutocompleteAddress from "components/Input/InputAutocompleteAddress";
import AppConfig from "config/AppConfig";
import CustomDatePicker from "components/Input/CustomDatePicker";
import moment from "moment";
const { PATTERNS } = AppConfig;
const maskNumber = '999999999999999';
const maskNumber10 = "9999999999";
const GeneralInformationForm = (props) => {
  const {
    onSubmit,
    isSubmitting,
    clientDetail = {},
    changeProgressStatus,
    display,
    hidePersonalInfo,
    hideLeftControl,
    disabled,
    type,
    disabledContactInfo
  } = props;

  const { t } = useTranslation();

  const [initForm, setInitForm] = useState({
    email: '',
    emailClient: '',
    firstName: '',
    lastName: '',
    organizationName: '',
    address1: '',
    address2: '',
    postalCode: '',
    ndisPlanNumber: '',
    phone: '',
    dateOfBirth: '',
    goal: '',
    emergencyContact: '',
    doctorDetail: '',
  });
  // const [isParticipant, setIsParticipant] = useState(false);
  const [latLng, setLatLng] = useState({});

  const {
    client = {}
  } = clientDetail;

  const {
    id: clientId,
    organizationName = '',
    address1 = '',
    address2 = '',
    postalCode = '',
    phone = '',
    emailClient = '',
    clientType = type,
    ndisPlanNumber = '',
    dateOfBirth = '',
    goal = '',
    emergencyContact = '',
    doctorDetail = '',
    personalInfoEmail = '',
    firstName = '',
    lastName = ''
  } = client;

  const {
    lat,
    lng
  } = latLng || {};

  const validationSchema = Yup.object().shape({
    email: !hidePersonalInfo &&
      Yup.string().trim()
        .required('validation.email.required')
        .email('validation.email.invalid')
        .max(255, { message: 'validation.max_length', value: 255 })
        .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
    emailClient: Yup.string().trim()
      .required('validation.email.required')
      .email('validation.email.invalid')
      .max(255, { message: 'validation.max_length', value: 255 })
      .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
    firstName: !hidePersonalInfo && YupValidations.requiredString.max(35, "validation.max_length_35"),
    lastName: !hidePersonalInfo && YupValidations.requiredString.max(35, "validation.max_length_35"),
    address1: YupValidations.requiredString,
    address2: Yup.string().max(240, "validation.max_length_240"),
    organizationName: (clientType === CLIENT_TYPE.SINGLE_USER_HOSPITAL ||
      clientType === CLIENT_TYPE.MULTIPLE_USER_HOSPITAL) ?
      YupValidations.requiredString : Yup.string().max(240, "validation.max_length_240"),
    postalCode: YupValidations.postalCode,
    phone: YupValidations.phone,
    ndisPlanNumber: YupValidations.requiredString,
    dateOfBirth: Yup.string()
      .test('dateOfBirth', "validation.max_date_of_birth", (dateOfBirth) => {
        if (!dateOfBirth || dateOfBirth === '') {
          return true;
        }
        if (moment(dateOfBirth).diff(moment(new Date().setHours(0, 0, 0, 0))) >= 0) {
          return false;
        } else {
          return true;
        }
      }),
    goal: Yup.string().trim().max(1000, "validation.max_length_1000")
  });

  useEffect(() => {
    if (clientDetail && Object.keys(clientDetail).length > 0) {
      const initial = {
        email: personalInfoEmail,
        emailClient,
        firstName,
        lastName,
        organizationName,
        address1,
        address2,
        postalCode,
        phone,
        ndisPlanNumber,
        dateOfBirth,
        goal,
        emergencyContact,
        doctorDetail,
      };
      setInitForm(initial);

      setTimeout(() => {
        validationSchema
          .isValid(initial)
          .then((valid) => {
            changeProgressStatus(0, valid);
          });
      }, 100);
    }
  }, [clientDetail]);

  const handleSubmitForm = (form) => {
    const params = {
      ...form,
      lat,
      lng
    };
    // !!clientId && delete params.email;
    onSubmit(params);
  };

  const styles = makeStyles(() => ({
    loginContainer: {
      width: "calc(100% + 30px)",
      margin: "0 10px",
    },
    title: {
      display: 'flex',
      margin: '2rem 0 1rem 0',
      '& h5': {
        color: AppColor.mainColor,
      }
    },
    control: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: clientId ? 'space-between' : 'flex-end',
      '& a': {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: AppColor.pink
      }
    }
  }));
  const classes = styles();

  return (
    <Formik
      enableReinitialize={true}
      onSubmit={handleSubmitForm}
      initialValues={initForm}
      validationSchema={validationSchema}
    >
      {({ setFieldValue }) => {
        return (
          <Form className={`${!display && 'hidden'}`}>
            {/* {
              !hidePersonalInfo && (
                <React.Fragment>
                  <Box className={classes.title}>
                    <Typography variant="h5">
                      {t("title.personalInformation")}
                    </Typography>
                  </Box>
                  <Field
                    component={AppInput}
                    name={'email'}
                    label={"label.email"}
                    required
                    // disabled={!!clientId || disabled}
                  />
                  <Field
                    component={AppInput}
                    name="firstName"
                    label={"label.firstName"}
                    required
                    disabled={disabled}
                  />
                  <Field
                    component={AppInput}
                    name="lastName"
                    label={"label.lastName"}
                    required
                    disabled={disabled}
                  />
                </React.Fragment>
              )
            } */}
            <Box className={classes.title}>
              <Typography variant="h5">
                {t("title.contactInformation")}
              </Typography>
            </Box>
            <React.Fragment>

              <Field
                component={AppInput}
                name="organizationName"
                id="organizationName"
                label={"label.organizationName"}
                required={clientType === CLIENT_TYPE.SINGLE_USER_HOSPITAL ||
                  clientType === CLIENT_TYPE.MULTIPLE_USER_HOSPITAL}
                disabled={disabled || disabledContactInfo}
              />
              <Field
                component={AppInput}
                name="emailClient"
                label={"label.emailOrganization"}
                required
                disabled={disabled || disabledContactInfo}
              />
              <Field
                component={AppInput}
                name="firstName"
                label={"label.firstName"}
                required
                disabled={disabled}
              />
              <Field
                component={AppInput}
                name="lastName"
                label={"label.lastName"}
                required
                disabled={disabled}
              />
              <Field
                component={AppInput}
                name={'email'}
                label={"label.email"}
                required
              // disabled={!!clientId || disabled}
              />
            </React.Fragment>
            <Field
              component={InputAutocompleteAddress}
              name="address1"
              label={"label.address1"}
              onChangePostalCode={postalcode => {
                setFieldValue("postalCode", postalcode);
              }}
              onChangeLatLng={latlng => setLatLng(latlng)}
              required
              disabled={disabled || disabledContactInfo}
            />
            <Field
              component={AppInput}
              name="address2"
              id="address2"
              label={"label.address2"}
              disabled={disabled || disabledContactInfo}
            />
            <Field
              component={AppInput}
              name="postalCode"
              type="tel"
              mask={maskNumber10}
              maskChar=""
              label={"label.postalCode"}
              required
              disabled={disabled || disabledContactInfo}
            />
            <Field
              component={AppInput}
              name="phone"
              type="tel"
              mask={maskNumber}
              maskChar=""
              id="phone"
              label={"label.phone"}
              required
              disabled={disabled || disabledContactInfo}
            />
            <Field
              component={AppInput}
              name="ndisPlanNumber"
              label={"label.ndisPlanNumber"}
              required
              disabled={disabled}
            />
            <Field
              component={CustomDatePicker}
              name="dateOfBirth"
              type="text"
              id="dateOfBirth"
              label={"label.dateOfBirth"}
              formatDateJob={true}
              custom={{
                openTo: "year",
                views: ["year", "month", "date"],
                maxDate: new Date(moment(new Date().setDate(new Date().getDate() - 1)))
              }}
              disabled={disabled}
            />
            <Field
              component={AppInput}
              name="emergencyContact"
              label={"label.emergencyContact"}
              disabled={disabled}
            />
            <Field
              component={AppInput}
              name="doctorDetail"
              label={"label.doctorDetail"}
              disabled={disabled}
            />
            <Field
              component={AppInput}
              name="goal"
              label={"label.goal"}
              type='textarea'
              disabled={disabled}
            />
            {
              !disabled && (
                <FormGroup className={classes.control}>
                  {
                    !hideLeftControl && (
                      <Link to="/search-worker">{t('text.completeLateAndSearchWorkers')}</Link>
                    )
                  }
                  <AppButton
                    label={`${t("button.saveAndContinue")}`}
                    rounder
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </FormGroup>
              )
            }
          </Form>
        );
      }}
    </Formik>
  );
};

GeneralInformationForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isCreate: PropTypes.bool,
  disabled: PropTypes.bool,
  hidePersonalInfo: PropTypes.bool,
  hideLeftControl: PropTypes.bool,
  display: PropTypes.bool,
  disabledContactInfo: PropTypes.bool,
  type: PropTypes.string,
  clientDetail: PropTypes.object,
  changeProgressStatus: PropTypes.func
};

export default GeneralInformationForm;
